import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart } from "chart.js/auto";
import { useTranslation } from "react-i18next";

Chart.register();

// Grade colors mirror the Tailwind theme (tailwind.config.js > colors.grade).
const GRADE_COLORS = {
  green: "#05CD99",
  orange: "#FBBC05",
  red: "#EF4040",
  non_graded: "#9CA3AF",
};

const options = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    datalabels: { display: false },
    legend: {
      display: true,
      position: "bottom",
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        padding: 12,
        font: { family: "DM Sans", size: 11 },
        color: "#737373",
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => ` ${context.dataset.label}: ${context.parsed.x}`,
      },
    },
  },
  scales: {
    x: {
      stacked: true,
      beginAtZero: true,
      ticks: { precision: 0, color: "#737373" },
      grid: { display: false },
    },
    y: {
      stacked: true,
      ticks: { color: "#404040", font: { family: "DM Sans", size: 12 } },
      grid: { display: false },
    },
  },
};

// data: { labels: string[], green: number[], orange: number[], red: number[], non_graded: number[] }
const StackedBarChart = ({ data }) => {
  const { t } = useTranslation();
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: t("Green"),
        data: data.green,
        backgroundColor: GRADE_COLORS.green,
        borderWidth: 0,
        barThickness: 18,
      },
      {
        label: t("Orange"),
        data: data.orange,
        backgroundColor: GRADE_COLORS.orange,
        borderWidth: 0,
        barThickness: 18,
      },
      {
        label: t("Red"),
        data: data.red,
        backgroundColor: GRADE_COLORS.red,
        borderWidth: 0,
        barThickness: 18,
      },
      {
        label: t("Not graded"),
        data: data.non_graded,
        backgroundColor: GRADE_COLORS.non_graded,
        borderWidth: 0,
        barThickness: 18,
      },
    ],
  };

  // Grow with the number of departments so bars stay readable; the parent
  // scrolls when this exceeds its max height.
  const chartHeight = Math.max(280, (data.labels?.length || 0) * 42 + 40);

  return (
    <div style={{ width: "100%", height: `${chartHeight}px`, position: "relative" }}>
      <Bar
        data={chartData}
        options={options}
        width="auto"
        height="100%"
      />
    </div>
  );
};

export default StackedBarChart;
